import React from 'react';

import GroupAffiliationPromotion from '../../../../components/group-affiliation-promotion/group-affiliation-promotion';
import ProductPromosOrDTCC from '../../../../components/product-promos-or-dtcc/product-promos-or-dtcc';
import EasyPayOptions from '../easy-pay-options/easy-pay-options';

import { isArrayWithLength } from '../../../../shared/utils/validators/validators';

import { PromotionData } from '../../../../shared/types/graphql-types';
import { MapPrice } from '../../../../shared/types/product';
import { PageTypes } from '../../../../shared/constants/page-types';

import './pdp-deals-section.scss';

interface PdpDealsSectionProps {
  brand?: string;
  combinedMapPrice: MapPrice;
  instantStrikethroughSavingsPerProduct?: number;
  isAddToCartDisabled: boolean;
  isCanonicalProduct: boolean;
  productType?: string;
  promos: Array<PromotionData>;
  totalStrikethroughSavings?: number;
}

function PdpDealsSection(props: PdpDealsSectionProps) {
  const {
    brand,
    combinedMapPrice,
    instantStrikethroughSavingsPerProduct,
    isAddToCartDisabled,
    isCanonicalProduct,
    productType,
    promos,
    totalStrikethroughSavings
  } = props;
  const hasPromos = isArrayWithLength(promos);

  return (
    <div styleName="deals">
      <GroupAffiliationPromotion showTitle styleName="group-affiliation" />
      <EasyPayOptions />
      <div styleName="deals-promos">
        <ProductPromosOrDTCC
          brand={brand}
          combinedMapPrice={combinedMapPrice}
          hasPromotions={hasPromos}
          instantStrikethroughSavingsPerProduct={
            instantStrikethroughSavingsPerProduct
          }
          pageType={PageTypes.PDP}
          productType={productType}
          promotionData={promos}
          showDtccBanner={
            !isCanonicalProduct && !isAddToCartDisabled && !hasPromos
          }
          showDuration
          showLongDescription
          totalStrikethroughSavings={totalStrikethroughSavings}
        />
      </div>
    </div>
  );
}

export default PdpDealsSection;
